export interface RevenueShareFormData {
  // confirmation of ownership
  doesNotViolate: boolean;

  suitableForChildren: boolean;
  // eligible for revenue share
  isEligible: boolean;
  // increase revenue share
  makeExclusive: boolean;
  hasImplementedSDK: boolean;
  hasCustomContract: boolean;
}

export function buildDefaultRevenueShareFormData(): RevenueShareFormData {
  return {
    doesNotViolate: false,
    suitableForChildren: false,
    isEligible: false,
    makeExclusive: false,
    hasImplementedSDK: false,
    hasCustomContract: false,
  };
}

export type RevenueShareFormProblems = 'TNC_NOT_ACCEPTED';

export function validateRevenueShareForm(form: RevenueShareFormData, isInvited: boolean): RevenueShareFormProblems[] {
  const { doesNotViolate, suitableForChildren, hasCustomContract } = form;
  if (isInvited) {
    if (!doesNotViolate && !hasCustomContract) {
      return ['TNC_NOT_ACCEPTED'];
    }
    return suitableForChildren ? [] : ['TNC_NOT_ACCEPTED'];
  } else if (doesNotViolate && suitableForChildren) {
    return [];
  }
  return ['TNC_NOT_ACCEPTED'];
}
